<template>
  <v-form ref="form" >

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>
      <v-col cols="12">
        <v-autocomplete
          v-model="entry.personId"
          v-bind="getObject('personId')"
          label="Funcionário"
          :items="extraData.accountContext.allEmployees"
          item-value="id"
          item-text="name"
          :disabled="readOnly"
          @input="selectEmployee"
        >
          <template v-slot:append-outer>
            <personNew
              :inlineAddButton="true"
              :isEmployee="true"
              @entry-created="personCreated"
              modelNameSingular="Funcionário"
            />
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <DateField
          :inputData.sync="entry.startDate"
          v-bind="getObject('startDate')"
          label="Data de Início"
          :hasTodayButton="true"
          :hasTodayDate="true"
          :disabled="readOnly"
          autocomplete="off"
        />
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <DateField
          :inputData.sync="entry.endDate"
          v-bind="getObject('endDate')"
          label="Data de Término"
          :hasTodayButton="true"
          :hasTodayDate="true"
          :disabled="readOnly"
          autocomplete="off"
        />
      </v-col>

      <v-col cols="6" sm="6" md="3">
        <MaskedTextField
          v-if="renderComponent"
          v-bind="getObject('durationInHours')"
          :inputData.sync="entry.durationInHours"
          mask-type="integer"
          label="Duração (horas)"
          @update:inputData="formatDurationText"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="6" sm="6" md="3">
        <MaskedTextField
          v-if="renderComponent"
          v-bind="getObject('durationInMinutes')"
          :inputData.sync="entry.durationInMinutes"
          mask-type="integer"
          label="Duração (minutos)"
          @update:inputData="formatDurationText"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" v-if="withPatrimonies">
        <v-autocomplete
          v-model="entry.patrimonyId"
          v-bind="getObject('patrimonyId')"
          label="Patrimônio"
          :items="extraData.accountContext.allPatrimoniesExceptImplements"
          item-value="id"
          item-text="description"
          :disabled="readOnly"
          @input="selectPatrimony"
          autocomplete="off"
        >
          <template v-slot:append-outer>
            <PatrimonyNew
              :inlineAddButton="true"
              @entry-created="patrimonyCreated"
              modelNameSingular="Patrimônio"
            />
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" v-if="withPatrimonies">
        <v-autocomplete
          v-model="entry.implementId"
          v-bind="getObject('implementId')"
          label="Implemento/Reboque"
          :items="extraData.accountContext.allPatrimoniesOfImplementCategory"
          item-value="id"
          item-text="description"
          :disabled="readOnly"
          @input="selectImplement"
          autocomplete="off"
        >
          <template v-slot:append-outer>
            <PatrimonyNew
              :inlineAddButton="true"
              @entry-created="implementCreated"
              modelNameSingular="Implemento/Reboque"
            />
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import personNew from "@models/people/new.vue"
import PatrimonyNew from "@models/patrimonies/new.vue"
import BaseUtil from "@shared_components/base_util.vue"
import DateField from "@shared_components/date_field.vue";

export default {
  data() {
    return {
      entryAttributes: {},
      renderComponent: true,
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    withPatrimonies: {
      type: Boolean,
      default: true
    },
    initialDate: {
      type: String,
      default: null
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    BaseUtil: BaseUtil,
    personNew: personNew,
    PatrimonyNew: PatrimonyNew,
    DateField: DateField
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
    
    if (this.initialDate && this.entry.startDate == null) {
      this.entry.startDate = this.initialDate;
      this.entry.endDate = this.initialDate;
    }
  },
  mounted() {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      // console.log(this.entry.durationInHours, this.entry.durationInMinutes);

      if (this.entry.durationInHours <= 0 && this.entry.durationInMinutes <= 0) {
        this.$refs.util.showErrorMessage("A duração da atividade deve ser maior do que 0 horas e 0 minutos.");
        return false;
        // this.entryAttributes.durationInHours.rules = [];
        // this.entryAttributes.durationInHours.rules.push(this.requiredRule);
        // this.entryAttributes.durationInHours.rules.push(this.minRequiredRule);

        // this.entryAttributes.durationInMinutes.rules = [];
        // this.entryAttributes.durationInMinutes.rules.push(this.requiredRule);
        // this.entryAttributes.durationInMinutes.rules.push(this.minRequiredRule);
        
      } 
      // else {
      //   this.entryAttributes.durationInHours.rules = [];
      //   this.entryAttributes.durationInHours.rules.push(this.requiredRule);

      //   this.entryAttributes.durationInMinutes.rules = [];
      //   this.entryAttributes.durationInMinutes.rules.push(this.requiredRule);
      // }
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    selectEmployee: function() {
      this.entry.person = this.extraData.accountContext.allEmployees.find(obj => obj.id == this.entry.personId);
    },
    selectPatrimony: function() {
      this.entry.patrimony = this.extraData.accountContext.allPatrimoniesExceptImplements.find(obj => obj.id == this.entry.patrimonyId);
    },
    selectImplement: function() {
      this.entry.implement = this.extraData.accountContext.allPatrimoniesOfImplementCategory.find(obj => obj.id == this.entry.implementId);
    },
    formatDurationText: function() {
      this.entry.durationInHours = this.entry.durationInHours ? this.entry.durationInHours : 0;
      this.entry.durationInMinutes = this.entry.durationInMinutes ? this.entry.durationInMinutes : 0;
      
      this.entry.durationText = this.entry.durationInHours + "h"
      
      if (this.entry.durationInMinutes < 10) {
        this.entry.durationText += "0";
      }
      this.entry.durationText += this.entry.durationInMinutes + "min";
    },
    clearFields: function() {
      this.forceRerender(this);
    },
    personCreated: function(person) {
      //testar pra ver se o tipo é supplier
      if (person.isEmployee) {
        this.extraData.accountContext.allEmployees.unshift(person);
        this.entry.personId = person.id;
        this.entry.person = person;
      } else {
        this.$refs.util.showErrorMessage("A pessoa cadastrada não é do tipo Funcionário, por isso não irá aparecer na lista de funcionários!");
      }
    }, 
    patrimonyCreated: function(patrimony) {
      //testar pra ver se o tipo é supplier
      if (patrimony.patrimonyCategory.kind == "implements") {
        this.$refs.util.showErrorMessage("O patrimônio cadastrado é do tipo Implemento, por isso não irá aparecer na lista de patrimônios!");
      } else {
        this.extraData.accountContext.allPatrimoniesExceptImplements.unshift(patrimony);
        this.entry.patrimonyId = patrimony.id;
        this.entry.patrimony = patrimony;
      }
    },
    implementCreated: function(implement) {
      //testar pra ver se o tipo é supplier
      if (implement.patrimonyCategory.kind == "implements" || implement.patrimonyCategory.kind == "trailer") {
        this.extraData.accountContext.allPatrimoniesOfImplementCategory.unshift(implement);
        this.entry.implementId = implement.id;
        this.entry.implement = implement;
      } else {
        this.$refs.util.showErrorMessage("O patrimônio cadastrado não é do tipo Implemento ou Carreta/Reboque, por isso não irá aparecer na lista de implementos!");
      }
    }
  }
};


</script>

<style scoped></style>
